<template>
  <div class="user-name-data-cell">
    <div class="user-name-data-cell__logo" >
      <img v-if="logo" :src="logo" class="avatar-image"/>
      <img v-else src="../../../assets/icons/noun_avatar_icn.svg" class="avatar-image">
    </div>
    <div class="user-name-data-cell__data">
      {{ item[column.name] }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserNameTableCell',
  computed: {
    logo() {
      if (!this.item.logo || this.item.logo.startsWith('data')) {
        return this.item.logo;
      }
      return `${this.item.logo}?${Date.now().toString()}` || null;
    },
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
};

</script>
<style scoped lang="scss">
@import '~@/assets/styles/design-system';

.user-name-data-cell {
  display: flex;
  align-items: center;
  &__data{
    text-transform: capitalize;
    flex: fit-content;
    padding-top: 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 3%;
    padding-left: 10px;
    font-family: $font-family-medium;
  }
  &__logo {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 1%;
    padding-left: 3px;
    .avatar-image{
      max-width: 40px;
      max-height: 40px;
      border-radius: 50%;
      border: 1px solid var(--brand-primary);
    }
  }
}
</style>
